import * as React from "react";
import { FilterInputType } from "../../../../../src/Enums/FilterTypes";
import FilterToolbar from "../../../../../src/Components/FiltersToolbar/FilterToolbar";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../Constants/Constant";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { SourceRequestOrder } from "../../Constant/Source";
import { DataGridColumns } from "./DataGridColumns";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { Drawer, Grid, makeStyles } from "@material-ui/core";
import RequestOrderNotes from "../RequestOrderNotes";
import { RemarkTypes } from "../../../../../src/Enums/RemarkTypes";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "20%",
  },
}));

export const WorkshopList = props => {
  useVerifyPermission("customroutes", "workshop.read");
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [requestRemark, setRequestRemark] = React.useState<any>({});
  const classes = useStyles();
  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Status",
          key: "Status",
        },
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer Po",
          key: "Customer Po",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Pn",
          key: "Pn",
        },
        {
          header: "Core Unit Sn",
          key: "Core Unit Sn",
        },
        {
          header: "Wo",
          key: "Wo",
        },
        {
          header: "Ro",
          key: "Ro",
        },
        {
          header: "Workshop",
          key: "Workshop",
        },
        {
          header: "Workshop Start Date",
          key: "Workshop Start Date",
        },
      ],
      data.map(v => [
        v.requestStatus,
        v.refNo,
        v.customerPo,
        v.requestedDeliveryDate,
        v.customerRequestComponent,
        v.unserviceable?.sn,
        v.wo,
        v.ro,
        v.workshop,
        v.unserviceable?.updatedDate,
      ]),
      "Workshop List"
    );
  };
  const remarkAddClick = record => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  };

  const handleClose = () => {
    setIsMatchCreate(false);
  };
  return (
    <Grid container>
      <Grid item xs={isMatchCreate ? 9 : 12}>
        <PoolList
          {...props}
          title={"Workshop List"}
          hasCreate={false}
          exporter={ExportToExcel}
          resource={SourceRequestOrder}
          basePath={SourceRequestOrder}
          hasBulkActions={false}
          filterDefaultValues={{
            isUnsvcInfo__eq: true,
            [`requestStatus = ${RequestStatus.Status22} || requestStatus =  ${RequestStatus.Status24}`]: "test",
          }}
          filters={
            <FilterToolbar
              dataSource={[
                {
                  source: "requestStatus",
                  inputType: FilterInputType.Select,
                  label: "Status",
                  optionText: "label",
                  optionValue: "id",
                  style: { width: "250px" },
                  choices: [
                    { label: "Status 22", id: RequestStatus.Status22 },
                    { label: "Status 24", id: RequestStatus.Status24 },
                  ],
                },
                {
                  source: "refNo",
                  inputType: FilterInputType.Text,
                  label: "Ref No",
                },
                {
                  source: "customerPo",
                  inputType: FilterInputType.Text,
                  label: "Customer Po",
                },
                {
                  source: "requestedDeliveryDate",
                  inputType: FilterInputType.Date,
                  label: "Requested Delivery Date",
                },
                {
                  source: "customerRequestComponent",
                  inputType: FilterInputType.Text,
                  label: "Pn",
                },
                {
                  source: "unserviceable.sn",
                  inputType: FilterInputType.Text,
                  label: "Sn",
                },
                {
                  showTime: true,
                  source: "unserviceable.updatedDate",
                  inputType: FilterInputType.Date,
                  label: "Workshop Start Date",
                },
              ]}
            />
          }
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
        >
          <DataGridColumns remarkAddClick={remarkAddClick} />
        </PoolList>
      </Grid>
      {isMatchCreate && (
        <Grid item xs={3}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <RequestOrderNotes
                onCancel={handleClose}
                request={requestRemark}
                resource="requestremarks"
                basePath="requestremarks"
                remarkType={RemarkTypes.PbhNote}
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
    </Grid>
  );
};

export default WorkshopList;
